module.exports = __webpack_public_path__ + "img/ModularWallV9.0a43520f.jpg";